<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 lg12>
        <v-card>
          <v-card-title class="align-baseline">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="filteredAnnouncements"
            class="announcements-table"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-icon>{{
                  props.item.projectId != null ? "done" : "query_builder"
                }}</v-icon>
              </td>
              <td>{{ props.item.title }}</td>
              <td>{{ props.item.address }}</td>
              <td>{{ props.item.createdAt | date }}</td>
              <td>{{ props.item.saleTrigram }}</td>
              <td>{{ statusName(props.item.currentProgress) }}</td>
              <td style="display: flex; justify-content: flex-end">
                <v-btn icon :to="`/announcement/${props.item._id}`">
                  <v-icon>arrow_right</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <v-snackbar v-model="showError" :timeout="7000"
            >Une erreur a eu lieu</v-snackbar
          >
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { ANNOUNCEMENTS_COLUMNS_NAMES } from "../data/DefaultSettings";

export default {
  data: function () {
    return {
      search: "",
      showError: false,
      headers: [
        {
          text: "",
          sortable: false,
        },
        {
          text: "Titre",
          value: "title",
        },
        {
          text: "Adresse",
          value: "address",
        },
        {
          text: "Enr. le",
          value: "createdAt",
        },

        {
          text: "Commercial",
          value: "saleTrigram",
        },
        {
          text: "Statut",
          value: "currentProgress",
        },
        {
          text: "",
          sortable: false,
        },
      ],
      pagination: { sortBy: "createdAt", descending: true, rowsPerPage: -1 },
    };
  },
  beforeMount() {
    this.reload();
  },
  computed: {
    ...mapState("announcements", {
      announcements: (state) => state.all,
    }),
    filteredAnnouncements() {
      if (this.search !== "") {
        const search = this.search.toLowerCase();
        return this.announcements.filter(
          ({ title, address, saleTrigram }) =>
            (title && title.toLowerCase().includes(search)) ||
            (address && address.toLowerCase().includes(search)) ||
            (saleTrigram && saleTrigram.toLowerCase().includes(search))
        );
      } else {
        return this.announcements;
      }
    },
  },
  methods: {
    ...mapActions("announcements", {
      resetAnnouncements: "reset",
      listAnnouncements: "list",
    }),
    async reload() {
      await this.resetAnnouncements();
      await this.listAnnouncements();
    },
    statusName(key) {
      return ANNOUNCEMENTS_COLUMNS_NAMES[key];
    },
  },
};
</script>
